module.exports = __webpack_public_path__ + "static/img/banner-tiu.9ace521.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-tiu.jpg
// module id = /C9F
// module chunks = 1